<template>
  <div class="old-entity-banner p-4 mb-4">
    <div class="bold text-large text-center">
      This {{ entityName }} is in a timeline that has ended ({{ timeline }})
    </div>
    <div class="flex-center mt-3">
      <div class="d-flex flex-wrap justify-content-center align-items-center">
        <b-button
          variant="primary"
          pill
          class="py-1 text-small-1"
          @click="isCloseEntityModalShown = true"
          >Close this {{ entityName }}
        </b-button>
        <div class="ml-2">
          Or
          <router-link class="text-prime text-medium-1" :to="editGoalLocation"
            >change its timeline
          </router-link>
          to continue working on it
        </div>
      </div>
    </div>
    <close-entity
      :entity="entity"
      v-if="isCloseEntityModalShown"
      v-model="isCloseEntityModalShown"
      @closed="$emit('closed')"
    />
  </div>
</template>

<script>
import { ENTITY_MAP, ENTITY_TYPE } from '@/constants/entities'
import { getEditGoalPageRouteConfig } from '@/utils/navigationConfigs'
import { mapGetters } from 'vuex'
import { BButton } from 'bootstrap-vue'
import CloseEntity from '@/components/CloseEntity'
import { intervalWithId } from '@/interval'

/**
 * This is a notification banner for Goal/KR
 * It is shown when goal/kr belongs to older timeline and still open.
 * User gets an option to close the goal/Kr
 */
export default {
  name: 'OldEntityBanner',
  props: ['krId', 'goalId'],
  components: {
    CloseEntity,
    BButton
  },
  data() {
    return {
      isCloseEntityModalShown: false
    }
  },
  computed: {
    ...mapGetters(['keyResultById', 'goalById']),
    goal() {
      const goalId = this.goalId || this.kr.goalId
      return this.goalById(goalId)
    },
    kr() {
      return this.keyResultById(this.krId)
    },
    entityType() {
      return this.krId ? ENTITY_TYPE.KEY_RESULT : ENTITY_TYPE.GOAL
    },
    entity() {
      return this.entityType === ENTITY_TYPE.GOAL ? this.goal : this.kr
    },
    timeline() {
      const timeline = intervalWithId(this.goal.timeline)
      return timeline?.name
    },
    editGoalLocation() {
      const goalId = this.entityType === ENTITY_TYPE.GOAL ? this.entity.id : this.entity.goalId
      return getEditGoalPageRouteConfig({
        orgId: this.entity.organizationId,
        goalId,
        query: {
          section: 'timeline'
        }
      })
    },
    entityName() {
      return ENTITY_MAP[this.entityType].name
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/styleConfigurations';

.old-entity-banner {
  background: $notificationBG;
  border-radius: 10px;
}
</style>
